import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth as useOidcAuth } from "react-oidc-context";

import { tokenStore } from "core/authentication";
import { UI_URL } from "shared/urls.constant";
import { useAuth } from "core/authentication/auth-context";
import FullPageSpinner from "components/FullPageSpinner";
import { useSession } from "shared/hooks/useSession";

export default function SsoCallback() {
  const navigate = useNavigate();
  const { startSession } = useSession();
  const auth = useOidcAuth();
  const { login } = useAuth();

  const onAuthDone = useCallback(() => {
    const tokenInfo = {
      token: auth.user?.id_token,
      userDetail: {
        email: auth.user?.profile.email,
        name: auth.user?.profile.displayName,
        persona: auth.user?.profile.userType,
      },
    };
    startSession();
    tokenStore.setToken(tokenInfo);

    login();
    navigate(UI_URL.HOME);
  }, [auth]);

  useEffect(() => {
    if (auth.isAuthenticated) {
      onAuthDone();
    }
  }, [auth]);
  
  if (auth.isLoading) {
    return <FullPageSpinner message="Please wait.." />;
  }
 
  if (auth.error) {
    return <div>Error: {auth.error.message}</div>;
  }
 
  if (!auth.isAuthenticated) {
    return <div>Not authenticated.</div>;
  }

  return <></>;
}
